<template>
  <div class="my_address">
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div v-if="list.length > 0">
      <van-radio-group v-model="radio">
        <div class="ad1" v-for="(item,index) in list" :key="index">
          <div class="ad1-1" @click="select(item, index)">
            <div class="ad1-1-le">
              <img class="img" src="@/assets/image/icon_add@3x.png" alt />
            </div>
            <div class="ad1-1-ri">
              <div>{{item.address + item.addressDetail}}</div>
              <div>{{item.name}} &nbsp;&nbsp; {{item.tel}}</div>
            </div>
          </div>
          <div class="ad1-2">
            <div>
              <van-radio :name="item.id" class="div1" @click="select(item, index)">
                设置默认地址
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? $theme.u_assist_icon_radio_selected : $theme.u_assist_icon_radio_none" />
                </template>
              </van-radio>
            </div>
            <div class="div2" @click="onEdit(item, index)">编辑</div>
            <div class="div3" @click="onDelete(item)">删除</div>
          </div>
        </div>
        <div class="navbar-fixed" @click="onAdd">
          <div class="foot-btn">新增收货地址</div>
        </div>
      </van-radio-group>
    </div>
    <div class="ad1" v-else>
      <div class="ad2">
        <empt title="一个地址也没有" info="“快去添加收货地址，买买买吧”" :url="$theme.u_general_icon_empty" ></empt> 
        <div @click="onAdd" class="no2"><van-button class="but">添加收货地址</van-button></div>
      </div>
    </div>
    <div v-if="show">
      <addressModal leftTitle="修改前地址"  rightTitle="修改后地址" @closeModal="closeModal" :value.sync="show" type="user" :subOrderId="$route.query.subId" :addressId="addressId"/>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from '@/utils/common'
import empt from '@/views/shareDiscovery/components/emptyItem'
import addressModal from '@/views/beeorder/components/addressDetails'
export default {
  data() {
    return {
      show:false,
      loading: false,
      chosenAddressId: 1,
      addressId:0,
      list: [],
      imge1: require('@/assets/image/empty_icon.png'),
      radio:''
    };
  },
  methods: {
    onAdd() {
      // Toast("新增地址");
      this.$router.push({ path: "/addaddress" });
    },
    onEdit(item, index) {
      this.$router.push({ path: "/addaddress", query: { id: item.id } });
    },
    closeModal(item){
      if(item){
        this.upAddress(this.addressId)
      }
    },
    upDateAddress(item,flag){
      http({
        url: "base/user/address/update",
        method: "put",
        parmes: {
          id: item.id,
          isDefault: "y"
        }
      }).then(rps => {
        if (rps.code === 200) {
          if(flag){
            this.getData();
          }else{
            this.getData("back");
          }
          
        }
      });
    },
    select(item, index) {
      if(this.$route.query.subId){
        this.addressId = item.id;
        this.show = !this.show;
        this.upDateAddress(item,true)
      }else{
        this.upDateAddress(item)
      }

    },
    upAddress(id){
      let parmes ={
        id:id
      }
      this.http({
        url:'/order/appOrder/addressModify',
        method:'post',
        parmes:{
          "addressId": id,
	        "subOrderId": this.$route.query.subId
        }
      })
      this.upDateAddress(parmes)
    },
    onDelete(item) {
      this.$dialog
        .confirm({
          title: "",
          message: "确定删除吗?"
        })
        .then(() => {
          this.doDelete(item);
        })
        .catch(() => {
          // on cancel
        });
    },
    doDelete(item) {
      http({
        url: "base/user/address/delete/" + item.id,
        method: "get"
      }).then(rps => {
        if (rps.code === 200) {
          this.$notify({ type: "success", message: "删除成功！" });
          this.getData();
        }
      });
    },
    getData(flag) {
      this.loading = true;
      http({
        url: "base/user/address/findPage",
        method: "post",
        parmes: {
          pageIndex: 1,
          pageSize: 100
        }
      }).then(rps => {
        this.loading = false;
        this.$loading.hide();
        if (rps.code === 200) {
          let list = [];
          rps.data &&
            rps.data.forEach(item => {
              if (item.isDefault === "y") {
                this.chosenAddressId = item.id;
                this.radio = item.id;
              }
              list.push({
                name: item.userName,
                id: item.id,
                isDefault: item.isDefault === "y" ? true : false,
                address: item.areaName,
                cityId: item.cityId,
                tel: item.mobile,
                provinceId: item.provinceId,
                userId: item.userId,
                addressDetail: item.addressDetail
              });
            });
          this.list = list;
          // flag && this.$router.back();
          if(flag){
            // utils.finishPage();
            utils.goBack()
          }
        }
      });
    },

    onChange(value){
      localStorage.setItem('chosenAddressId', value);
      //this.$router.go({name: 'userSureOrder', params: {'chosenAddressId': value}});
      this.$router.go(-1);
    }
  },
  created() {
    this.getData();
    utils.nativeMethod({tm:'4000102',tp:{pageType_pvar:'我的地址'}})
    utils.nativeMethod({tm:'4000102',tp:{pageName_pvar:document.title}})
  },
  components:{empt,addressModal}
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.my_address {
  background-color: #f7f7f7;
  padding: 30px;
  padding-bottom: 120px;
}
.ad1 {
  font-size: 28px;
  color: #333333;
  border-radius: 20px;
  margin-bottom: 28px;
  background-color: #fff;
  .ad1-1 {
    padding-left: 40px;
    padding-right: 50px;
    padding-top: 59px;
    margin-bottom: 56px;
    display: flex;
    .ad1-1-le {
      width: 80px;
      height: 70px;
      text-align: center;
      padding-top: 10px;
    }
    .ad1-1-ri {
      margin-left: 20px;
      width: 80%;
    }
  }
  .ad1-2 {
    padding-left: 40px;
    padding-right: 50px;
    margin-top: 56px;
    border-top: 2px solid #f2f2f2;
    font-size: 24px;
    display: flex;
    height: 84px;
    line-height: 84px;
    justify-content: left;
    .div1 {
      height: 84px;
      line-height: 84px;
    }
    .div2 {
      margin-left: 250px;
    }
    .div3 {
      margin-left: 57px;
    }
    .img-icon{
      width: 30px;
      height: 30px;
    }
  }
  
}
.foot-btn {
  font-size: 26px;
  width: 600px;
  height: 88px;
  line-height: 88px;
  background-color: var(--buttonColor);
  border-radius: 44px;
  color: var(--textColor);
  text-align: center;
}
.navbar-fixed {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  z-index: 3;
  border-top: 0.01rem solid #fafafa;
  padding-top: 16px;
  padding-bottom: 16px;
}
.ad2{
  padding-top: 180px;
  padding-left: 150px;
  padding-right: 150px;
  padding-bottom: 200px;
}
.no2{
  text-align: center;
  margin: 20px 30px 68px 30px;
}
.but{
  width:240px;
  height:64px;
  background:var(--buttonColor);
  color: var(--textColor);
  border-radius:32px;
  line-height: 64px;
}
</style>